import React, { useCallback } from 'react'
import { GridContainer, GridItem, Link, ElementContainerScroll, ElementContaineItems } from './ListParticipants.styles'
import { Typography, useViewport } from '@chilecompra/react-kit'
import PropTypes from 'prop-types'
import { PURCHASING_MECHANISM } from '../../config/settings/constants'

/**
 * The Participant Elements.
 */
const ListParticipantsElementProcess = props => {
  const { data } = props
  const {
    size: { isDownToMedium }
  } = useViewport()

  const processedData = useCallback(() => {
    const purchaseMechanismList = []
    const contractFormList = []
    const purchaseOrdesList = []
    if (data.length > 0) {
      data.forEach(element => {
        const item = {
          groupName: element?.participantProcess?.process?.groupName,
          name: element?.participantProcess?.process?.name,
          processId: element?.participantProcess?.process?.processId,
          processNumber: element?.participantProcess?.processNumber,
          participantProcessLink: element?.participantProcess?.process?.participantProcessLink // it will be change to other key
        }
        if (element.participantProcess.processNumber) {
          if (element?.participantProcess?.process?.groupName === PURCHASING_MECHANISM[0].groupName) {
            if (
              contractFormList.filter(item => item?.processNumber === element?.participantProcess?.processNumber)
                .length === 0
            ) {
              contractFormList.push({ ...item, alias: PURCHASING_MECHANISM[0].alias })
            }
          } else if (
            element?.participantProcess?.process?.groupName === PURCHASING_MECHANISM[1].groupName ||
            element?.participantProcess?.process?.groupName === PURCHASING_MECHANISM[2].groupName ||
            element?.participantProcess?.process?.groupName === PURCHASING_MECHANISM[3].groupName ||
            element?.participantProcess?.process?.groupName === PURCHASING_MECHANISM[5].groupName ||
            element?.participantProcess?.process?.groupName === PURCHASING_MECHANISM[6].groupName ||
            element?.participantProcess?.process?.groupName === PURCHASING_MECHANISM[7].groupName ||
            element?.participantProcess?.process?.groupName === PURCHASING_MECHANISM[8].groupName ||
            element?.participantProcess?.process?.groupName === PURCHASING_MECHANISM[9].groupName
          ) {
            const process = PURCHASING_MECHANISM.find(({ name }) => element?.participantProcess?.process?.name === name)
            if (
              purchaseMechanismList.filter(item => item?.processNumber === element?.participantProcess?.processNumber)
                .length === 0
            ) {
              purchaseMechanismList.push({ ...item, alias: process?.alias || '' })
            }
          } else if (element?.participantProcess?.process?.groupName === PURCHASING_MECHANISM[4].groupName) {
            if (
              purchaseOrdesList.filter(item => item?.processNumber === element?.participantProcess?.processNumber)
                .length === 0
            ) {
              purchaseOrdesList.push({ ...item, alias: PURCHASING_MECHANISM[4].alias })
            }
          }
        }
      })
    }
    return { purchaseMechanismList, contractFormList, purchaseOrdesList }
  }, [data])

  const handleClickToUrl = path => () => {
    window.open(path, '_blank')
  }

  const { purchaseMechanismList, contractFormList, purchaseOrdesList } = processedData()

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Typography fontSize={isDownToMedium ? '18px' : '22px'} color="black1" fontWeight="bold" lineHeight="22px">
          Elementos del proceso de compra o contratación
        </Typography>
      </GridItem>
      <GridItem xs={12}>
        <Typography
          fontSize={isDownToMedium ? '14px' : '16px'}
          variant="body2"
          lineHeight="21px"
          padding="10px 0 20px 0"
        >
          Accede al mecanismo utilizado en este proceso de compra, sus órdenes de compra generadas y su ficha de
          contrato.
        </Typography>
      </GridItem>
      <ElementContainerScroll>
        <ElementContaineItems>
          {purchaseMechanismList && purchaseMechanismList.length > 0 && (
            <GridItem xs={12} container flexDirection="row">
              <GridItem xs={6} sm={4}>
                <Typography
                  fontSize={isDownToMedium ? '14px' : '16px'}
                  padding="10px 10px 0 0"
                  fontWeight="bold"
                  lineHeight="21px"
                >
                  Mecanismo de compra:
                </Typography>
              </GridItem>
              <GridItem xs={6} sm={8} padding="3px 0 10px" justifyContent="start">
                {purchaseMechanismList.length > 0 &&
                  purchaseMechanismList.map(
                    ({ processNumber, participantProcessLink, alias }, key) =>
                      processNumber && (
                        <Typography fontSize={isDownToMedium ? '14px' : '16px'} key={`purchase-mechanism-${key}`}>
                          <Link
                            textDecoration="underline"
                            component="button"
                            rel="noreferrer"
                            onClick={handleClickToUrl(`${participantProcessLink}`)}
                          >
                            {`${alias} ${processNumber || ''}`}
                          </Link>
                        </Typography>
                      )
                  )}
              </GridItem>
            </GridItem>
          )}
          {contractFormList && contractFormList.length > 0 && (
            <GridItem xs={12} container flexDirection="row">
              <GridItem xs={6} sm={4}>
                <Typography
                  fontSize={isDownToMedium ? '14px' : '16px'}
                  padding="10px 10px 0 0"
                  fontWeight="bold"
                  lineHeight="21px"
                >
                  Ficha de contrato:
                </Typography>
              </GridItem>
              <GridItem xs={6} sm={8} padding="3px 0 10px" justifyContent="start">
                {contractFormList.length > 0 &&
                  contractFormList.map(
                    ({ processNumber, participantProcessLink }, key) =>
                      processNumber && (
                        <Typography fontSize={isDownToMedium ? '14px' : '16px'} key={`contracts-${key}`}>
                          <Link
                            textDecoration="underline"
                            component="button"
                            rel="noreferrer"
                            onClick={handleClickToUrl(`${participantProcessLink}`)}
                          >
                            {processNumber}
                          </Link>
                        </Typography>
                      )
                  )}
              </GridItem>
            </GridItem>
          )}
          {purchaseOrdesList && purchaseOrdesList.length > 0 && (
            <GridItem xs={12} container flexDirection="row">
              <GridItem xs={6} sm={4}>
                <Typography
                  fontSize={isDownToMedium ? '14px' : '16px'}
                  padding="10px 10px 0 0"
                  fontWeight="bold"
                  lineHeight="21px"
                >
                  Órdenes de compra:
                </Typography>
              </GridItem>
              <GridItem xs={6} sm={8} padding="3px 0 10px" justifyContent="start">
                {purchaseOrdesList.length > 0 &&
                  purchaseOrdesList.map(
                    ({ processNumber, participantProcessLink }, key) =>
                      processNumber && (
                        <Typography fontSize={isDownToMedium ? '14px' : '16px'} key={`purchase-orders-${key}`}>
                          <Link
                            textDecoration="underline"
                            component="button"
                            rel="noreferrer"
                            onClick={handleClickToUrl(`${participantProcessLink}`)}
                          >
                            {processNumber}
                          </Link>
                        </Typography>
                      )
                  )}
              </GridItem>
            </GridItem>
          )}
        </ElementContaineItems>
      </ElementContainerScroll>
    </GridContainer>
  )
}

ListParticipantsElementProcess.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.number.isRequired,
      role: PropTypes.string,
      participantDetailId: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      dateUpdate: PropTypes.string.isRequired,
      creationDate: PropTypes.string.isRequired,
      fullName: PropTypes.string.isRequired,
      orgCode: PropTypes.number.isRequired,
      participantId: PropTypes.string.isRequired,
      participantProcess: PropTypes.shape({
        participantProcessId: PropTypes.string.isRequired,
        participantDetailId: PropTypes.string.isRequired,
        processId: PropTypes.number.isRequired,
        functionId: PropTypes.number.isRequired,
        processNumber: PropTypes.string,
        participantDetail: PropTypes.any,
        process: PropTypes.shape({
          processId: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          groupName: PropTypes.string.isRequired,
          active: PropTypes.number.isRequired,
          participantProcessLink: PropTypes.string.isRequired
        }).isRequired,
        function: PropTypes.shape({
          functionId: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          description: PropTypes.string.isRequired,
          active: PropTypes.number.isRequired
        }).isRequired
      }).isRequired,
      dni: PropTypes.string.isRequired
    })
  ).isRequired
}

ListParticipantsElementProcess.defaultProps = {
  data: [
    {
      active: 0,
      role: '',
      participantDetailId: '',
      email: '',
      dateUpdate: '',
      creationDate: '',
      fullName: '',
      orgCode: 0,
      participantId: '',
      participantProcess: {
        participantProcessId: '',
        participantDetailId: '',
        processId: 0,
        functionId: 0,
        processNumber: '',
        participantDetail: null,
        process: {
          processId: 0,
          name: '',
          groupName: '',
          active: 0
        },
        function: {
          functionId: 0,
          name: '',
          description: '',
          active: 0
        }
      },
      dni: ''
    }
  ]
}

export default ListParticipantsElementProcess
